import axios from 'axios';

import type { PostApiV1EventsData } from '~/api/generated';

export type EventSubmission = NonNullable<PostApiV1EventsData['body']>;

export async function createEvent(event: EventSubmission): Promise<void> {
  await axios.post('/api/v1/events', event);
}
